<sdps-modal-beta sdps-title="Cashiering IRA Agreement" back-drop-close-disabled="true" id="cashiering-ira-agreement-modal" (closeButtonClick)="onCloseClick()">
    <div slot="modal-body">
        <div class="sdps-text-body" [innerHTML]="modalBodyText"></div>
    </div>
    <div slot="modal-footer">
        <button (click)="onPrintClick()" type="button"
            class="sdps-button sdps-button--medium sdps-button--secondary">Print</button>
        <button (click)="onCloseClick()" type="button"
            class="sdps-button sdps-button--medium sdps-button--primary">Close</button>
        </div>
</sdps-modal-beta>